export function isIlrDevice(type?: string | null): boolean {
  return (
    String(type ?? '')
      .trim()
      .toUpperCase() === 'ILR'
  );
}
